import {Injectable} from '@angular/core';
import {IoService} from './io.service';
import {Column} from '../models';

@Injectable()
export class ColumnService extends IoService {
  protected model = Column;
  protected listUrl = '/columns/';
}
